import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vSelect from 'vue-select'

import './tailwind.css'
import 'vue-select/dist/vue-select.css'

Vue.component('VSelect', vSelect)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
